import { namespace } from 'vuex-class';
import { IChatState } from '@/document-view/chat/store/chat.types';

export const Chat = namespace('chat');

export const getDefaultState: () => IChatState = () => ({
  comments: [],
  commentsRead: [],
  loaded: false,
  unpublishedComment: null,
});
